import React from "react";
import {Col, ColorPicker, Row, Space} from "antd";
import {ColumnProps} from "antd/es/table";
import Moment from "moment";
const columns: ColumnProps<any>[] = [
  {key: "1", title: "Mã chỉ số", dataIndex: "idChiSo", align: "left"},
  {key: "2", title: "Mã xét nghiệm", dataIndex: "idDichVu", align: "left"},
  {key: "3", title: "Tên xét nghiệm", dataIndex: "tenDichVu", align: "left"},
  {key: "4", title: "Tên chỉ số", dataIndex: "tenChiSo"},
  {key: "5", title: "Mô tả", dataIndex: "moTa"},
  {key: "6", title: "Ghi chú", dataIndex: "ghiChu"},
  {key: "7", title: "Thao tác", dataIndex: "action"},
];
export {columns};
